import React from 'react';

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-4xl">
      <h1 className="text-4xl font-bold mb-6 text-center text-gray-800">Privacy Policy</h1>
      <p className="text-gray-600 mb-8 text-center">Effective Date: 1st November 2024</p>
      
      <div className="space-y-12">
        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">1. Introduction</h2>
          <p className="text-gray-700 leading-relaxed">
            Welcome to Shynerz Baby Shop. We value your privacy and are committed to protecting your personal information. 
            This Policy shows how we collect, use, disclose, and safeguard your information every time you visit our website.
          </p>
        </section>

        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">2. Data We Collect</h2>
          <p className="text-gray-700 mb-4">We will collect the following data that you will fill in by yourself:</p>
          <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
            <li>Name</li>
            <li>Phone number</li>
            <li>Email address</li>
            <li>Payment information (if applicable)</li>
            <li>Location</li>
          </ul>
        </section>

        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">3. How We Use Your Data</h2>
          <p className="text-gray-700 mb-4">We use the information we collect for various purposes, including:</p>
          <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
            <li>To monitor usage of our website</li>
            <li>To process orders, transactions and share with you related information</li>
            <li>To communicate with you on our customer service and support</li>
            <li>To share upon your consent our marketing communication</li>
          </ul>
        </section>

        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">4. Data Security</h2>
          <p className="text-gray-700 leading-relaxed">
            We will treat your data as strictly confidential. We will further employ appropriate technical and organizational 
            measures that will protect your personal information from unauthorized access, use, or disclosure. However, 
            please note that no electronic storage is 100% secure in the new era of internet.
          </p>
        </section>

        <section className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 border-b pb-2">Contact Us</h2>
          <p className="text-gray-700 leading-relaxed">
            If you have concerns about this privacy policy, please reach us at:{' '}
            <a href="mailto:sales.shynerz@gmail.com" className="text-blue-600 hover:text-blue-800 underline">
            sales.shynerz@gmail.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}; 